var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestaurants(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5695 5.69043C28.5695 5.69043 27.131 6.40966 26.5387 11.4443C26.3272 13.5174 26.6234 15.5904 27.3003 17.5366C27.3849 17.7481 27.4272 18.002 27.4272 18.2558L27.0464 23.3327V23.5866C27.0887 24.1789 27.5964 24.6866 28.1887 24.6866C28.6964 24.602 29.0772 23.925 29.0772 23.2904L28.5695 5.69043Z",
    fill: "white",
    stroke: "#CCCCCC",
    strokeWidth: 0.761538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4273 18.2135L27.0889 23.375V23.5866C27.0889 23.8827 27.1735 24.2212 27.385 24.4327C27.5966 24.6443 27.8927 24.7712 28.2312 24.7712C28.7389 24.6866 29.1196 24.0097 29.1196 23.375L28.9927 18.2981H27.4696V18.2135H27.4273Z",
    fill: "white",
    stroke: "#CCCCCC",
    strokeWidth: 0.761538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6021 24.2636C20.5791 24.2636 24.6137 20.229 24.6137 15.252C24.6137 10.2751 20.5791 6.24048 15.6021 6.24048C10.6252 6.24048 6.59058 10.2751 6.59058 15.252C6.59058 20.229 10.6252 24.2636 15.6021 24.2636Z",
    fill: "white",
    stroke: "#CCCCCC",
    strokeWidth: 0.761538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6027 19.7367C18.0794 19.7367 20.0873 17.7289 20.0873 15.2521C20.0873 12.7753 18.0794 10.7675 15.6027 10.7675C13.1259 10.7675 11.118 12.7753 11.118 15.2521C11.118 17.7289 13.1259 19.7367 15.6027 19.7367Z",
    fill: "white",
    stroke: "#FFCC09",
    strokeWidth: 0.761538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09489 11.9943H2.57181L1.81027 22.6135V22.9519C1.85258 24.0096 2.74104 24.8558 3.5872 24.6443C4.43335 24.3058 4.94104 23.4173 4.85643 22.4866L4.09489 11.9943ZM4.98335 5.77502V10.175C4.89873 10.9789 4.1795 11.5712 3.33335 11.5289C2.4872 11.5712 1.76796 10.9789 1.68335 10.1327V5.77502",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98335 5.77502V10.175C4.89873 10.9789 4.1795 11.5712 3.33335 11.5289C2.4872 11.5712 1.76796 10.9789 1.68335 10.1327V5.77502M4.09489 11.9943H2.57181L1.81027 22.6135V22.9519C1.85258 24.0096 2.74104 24.8558 3.5872 24.6443C4.43335 24.3058 4.94104 23.4173 4.85643 22.4866L4.09489 11.9943Z",
    stroke: "#CCCCCC",
    strokeWidth: 0.761538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33276 5.77502V11.6981",
    stroke: "#CCCCCC",
    strokeWidth: 0.761538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurants);
export default __webpack_public_path__ + "static/media/Restaurants.e8a9953706ce7c8b71e0b86c8d5e4743.svg";
export { ForwardRef as ReactComponent };